<template>
  <v-menu v-model="showMenu" max-height="250" :close-on-content-click="false" offset-y tile :allow-overflow="true">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        :placeholder="placeholder"
        :hide-details="hideDetails"
        readonly
        :append-icon="showMenu ? 'fa-caret-up' : 'fa-caret-down'"
        @click:append="handleIconClick"
        :value="inputValue"
        :dense="dense"
        :outlined="outlined"
        :rules="rules"
        :append-outer-icon="appendOuterIcon"
        v-on="on"
        v-bind="attrs"
        clearable
        @click:clear="handleClear"
        ref="text"
      />
    </template>
    <v-sheet>
      <div class="v-cascader">
        <v-cascader-item
          :items="items"
          :dense="dense"
          :selected-items="selectedItems"
          @input="handleInput"
          :value.sync="value"
          :item-text="itemText"
          :item-value="itemValue"
        />
      </div>
    </v-sheet>
  </v-menu>
</template>
<script>
import { findPath } from 'n-ary-tree'
import VCascaderItem from './VCascaderItem'
export default {
  name: 'v-cascader',
  components: {
    VCascaderItem
  },
  props: {
    items: Array,
    label: String,
    placeholder: String,
    name: String,
    dense: Boolean,
    outlined: Boolean,
    childrenKey: {
      type: String,
      default: 'children'
    },
    seperator: {
      type: String,
      default: ' / '
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    value: {
      type: [Array, Number, String],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    appendOuterIcon: {
      type: String,
      default: null
    },
    hideDetails: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectedItems() {
      const search = this.value
      return this.items
        .map((item) => {
          return findPath(item, search, {
            value: this.itemValue,
            children: this.childrenKey
          })
        })
        .filter((item) => item.length > 0)
        .pop()
    },
    inputValue() {
      return this.selectedItems ? this.selectedItems.map((item) => item[this.itemText]).join(this.seperator) : null
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val)
    },
    handleClear() {
      this.$emit('input', null)
    },
    handleIconClick() {
      this.showMenu = true
    }
  }
}
</script>
